// @flow
export const allRoleFillersId = '-2'
export const allCircleMembersId = '-1'
export const individualActionId = '0'
